import { Box } from '../../../shared_components/UI/Box'
import styled from 'styled-components'

export const FormBox = styled(Box)`
  gap: 16px;
  flex-direction: column;
  align-items: stretch;
`

export const RowInputBox = styled(Box)`
  display: flex;
  flex-direction: row;
  gap: 16px var(--Index-Grids-Gutters, 16px);

  @media (max-width: 768px) {
    flex-direction: column;
  }
`

export const InputBox = styled(Box)`
  flex-direction: column;
  gap: 8px;

  input,
  textarea {
    display: flex;
    padding: 13px var(--units-12, 12px);
    align-items: center;
    gap: var(--units-8, 8px);
    flex: 1 0 0;

    border-radius: var(--units-8, 8px);
    border: var(--units-1, 1px) solid var(--stroke-tertiary, #191919);
    background: var(--surface-minimal-invert, rgba(0, 0, 0, 0.4));

    width: 100%;
    height: 44px;
    resize: none;
    outline: none;

    color: var(--text-primary, #fff);
    /* Web/Text/M/Regular */
    font-family: var(--type-family-space-grotesk, 'Space Grotesk');
    font-size: var(--Text-M-M-size, 14px);
    font-style: normal;
    font-weight: var(--type-weight-Regular, 300);
    line-height: var(--Text-M-M-line-height, 18px); /* 128.571% */

    :hover,
    :active,
    :focus {
      background: transparent;
      border-color: rgba(255, 255, 255, 0.3);
    }
  }

  textarea {
    min-height: 88px;
  }
`

export const InputLabel = styled.label<{ required?: boolean }>`
  color: var(--text-primary, #fff);
  text-align: left;

  /* Web/Text/M/Semibold */
  font-family: var(--type-family-space-grotesk, 'Space Grotesk');
  font-size: var(--Text-M-M-size, 14px);
  font-style: normal;
  font-weight: var(--type-weight-Semibold, 600);
  line-height: var(--Text-M-M-line-height, 18px); /* 128.571% */
  letter-spacing: -0.28px;

  ${({ required }) =>
    required &&
    `
      &::after {
        content: '*';
        color: #FC8181;
        margin-left: 0.25rem;
      }
    `}
`
